import { render } from "./recordDetail.vue?vue&type=template&id=37ee9629&scoped=true"
import script from "./recordDetail.vue?vue&type=script&lang=js"
export * from "./recordDetail.vue?vue&type=script&lang=js"

import "./recordDetail.vue?vue&type=style&index=0&id=37ee9629&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ee9629"],['__file',"src/views/alfmeier/device/recordDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37ee9629"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37ee9629', __exports__)) {
    console.log('reload')
    api.reload('37ee9629', __exports__)
  }
  
  module.hot.accept("./recordDetail.vue?vue&type=template&id=37ee9629&scoped=true", () => {
    console.log('re-render')
    api.rerender('37ee9629', render)
  })

}


export default __exports__